<template>
  <div class="shade-chil">
    <!-- 头部区 -->
    <div>
      <i class="iconfont resource-icon">&#xe7c5;</i>
    <h1 class="resource-title">{{$t('message.请输入搜索员工手机号')}}</h1>
    <!-- 搜索框区 -->
        <div class="seek-box">
          <el-input
            type="text"
            :placeholder="$t('message.请输入搜索手机号')"
            v-model="searchContent"
            class="seek-main"
            clearable
          />
          <i class="iconfont seek-icon" @click="doSearch()">&#xe7b4;</i>
        </div>
    </div>
    <!-- 内容区 -->
    <div>
      <div style="height: 578px border-bottom: 1px solid #ddd">
      <div class="resource">
        
        <!-- 内容区 -->
        <div
          id="resourceList"
          class="resourceList"
          v-loading="loadingFlag"
          :element-loading-text="$t('message.拼命加载中')"
          element-loading-spinner="el-icon-loading"
        >
        <!-- 表格数据区 -->
          <el-table
            ref="singleTable"
            :data="this.filterData"
            tooltip-effect="dark"
            style="width: 100%"
            height="558"
            highlight-current-row
            @current-change="handleCurrentChange"
          >
            <el-table-column label="No." type="index" width="55">
            </el-table-column>
            <el-table-column
              sortable
              prop="backaccountid"
              label="ID"
              width="75"
            >
            </el-table-column>
            <el-table-column sortable prop="workname" label="workname" min-width="100">
            </el-table-column>
            <el-table-column sortable prop="name" :label="$t('message.姓名')" min-width="100">
            </el-table-column>
            <el-table-column sortable :label="$t('message.权限')" min-width="75">
              <template slot-scope="scope">
                <span>{{ $t(`message.${getAccountAuthName(scope.row.auth)}`) }}</span>
              </template>
            </el-table-column>
            <el-table-column sortable :label="$t('message.性别')" min-width="75">
              <template slot-scope="scope">
                <span>{{ $t(`message.${getAccountGenderName(scope.row.gender)}`) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              sortable
              prop="mobile"
              :label="$t('message.手机号码')"
              min-width="100"
            >
            </el-table-column>
            <el-table-column :label="$t('message.照片')" width="150" align="center">
              <template slot-scope="scope">
                <el-popover
                  v-if="scope.row.headimg != '' && scope.row.headimg != null"
                  placement="top-start"
                  title=""
                  trigger="hover"
                >
                  <img
                    :src="'' + scope.row.headimg"
                    alt=""
                    style="max-width: 500px; max-height: 500px"
                  />
                  <img
                    slot="reference"
                    :src="'' + scope.row.headimg"
                    style="max-width: 120px; max-height: 30px"
                  />
                </el-popover>
                <span v-else>{{$t('message.无')}}</span>
              </template>
            </el-table-column>
            <el-table-column width="150" sortable :label="$t('message.员工状态')">
              <template slot-scope="scope">
                <span>{{ $t(`message.${getAccountStateName(scope.row.state)}`) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    </div>
    <!-- 底部区 -->
    <div>
      <div class="myObject">{{ tableData.length }} {{$t('message.个项目')}}</div>
<!-- 底部按钮区域 -->
    <div class="on-btn">
      <el-button
        type=""
        size="mini"
        @click="doSearch"
        icon="el-icon-refresh"
        round
        >{{$t('message.刷新')}}</el-button
      >
      <el-button
        type=""
        size="mini"
        icon="el-icon-close"
        round
        @click="onCancelChoseAccount"
        >{{$t('message.关闭')}}</el-button
      >
      <el-button
        type="primary"
        size="mini"
        icon="el-icon-check"
        round
        @click="onSelect"
        >{{$t('message.选择')}}</el-button
      >
    </div>
    </div>
    
  </div>
</template>

<script>
import shade from "@/components/shade/shade";
import commonUtil from "@/utils/commonUtil";
import {rejecthttp,changeflagCLOSED} from "@/utils/request";

export default {
  name: "orginstore",

  components: {
    shade,
  },

  props: {},

  data() {
    return {
      tableData: [],
      loadingFlag: false,
      searchContent: "",
      currentRow:{},
    };
  },

  methods: {
    onCancelChoseAccount() {
      this.$emit("onCancelChoseAccount");
    },

    handleCurrentChange(val) {
      this.currentRow = val;
    },

    getAccountStateName(state) {
      return commonUtil.getAccountStateName(state);
    },

    getAccountGenderName(gender) {
      return commonUtil.getGenderName(gender);
    },

    getAccountAuthName(auth) {
      return commonUtil.getAccountAuthName(auth);
    },

    onSelect() {
      rejecthttp(true,'get',"/manage/organization/employee/getinfo",{
            appid: "188",
            userid:this.currentRow.backaccountid
          },this,(doc) => {
            changeflagCLOSED(doc,0,this)
            if(doc.data.Code == "MSGKEY_OK"){
              this.$emit("onSelectAccount", doc.data.data);
            }
            })
      // this.$http
      //   .get("/manage/organization/employee/getinfo", {
      //     params: {
      //       appid: "188",
      //       userid:this.currentRow.backaccountid
      //     },
      //   })
      //   .then((doc) => {
      //     if (doc.data.Code != "MSGKEY_OK") {
      //       this.$message({
      //         type: "error",
      //         message: doc.data.Message,
      //       });
      //     } else {
      //       console.log(doc.data.data);
      //       // this.serverData.backaccountid = doc.data.data.backaccountid;
      //       // this.serverData.name = doc.data.data.name;
      //       // this.serverData.gender = doc.data.data.gender;
      //       // this.serverData.mobile = doc.data.data.mobile;
      //       this.$emit("onSelectAccount", doc.data.data);
      //     }
      //   });
      
    },

    doSearch() {
      this.loadingFlag = true;
      this.loadingFlag = false;
    },
  },

  computed: {
    filterData() {
      if (this.tableData)
        return this.tableData.filter(
          (data) =>
            (!this.searchContent ||
              // data.name.includes(this.searchContent.toLowerCase()) ||
              data.workname
                .toLowerCase()
                .includes(this.searchContent.toLowerCase()) ||
              data.backaccountid
                .toString()
                .toLowerCase()
                .includes(this.searchContent.toLowerCase()) 
                // ||data.mobile
                // .includes(this.searchContent.toLowerCase())
                )
                &&(!this.selectedTypeID || data.type == this.selectedTypeID)
        );
      else return [];
    },
  },
  created() {},
  mounted() {
      this.loadingFlag = true;
      rejecthttp(false,'get',"/manage/organization/employee/getlist",{
            appid: "188",
          },this,(doc) => {
            changeflagCLOSED(doc,0,this)
            if(doc.data.Code == "MSGKEY_OK"){
              this.tableData = doc.data.data;
            }
            })
      // this.$http
      //   .get("/manage/organization/employee/getlist", {
      //     params: {
      //       appid: 188,
      //     },
      //   })
      //   .then((doc) => {
      //     if (doc.data.Code != "MSGKEY_OK") {
      //       this.$message({
      //         type: "error",
      //         message: doc.data.Message,
      //       });
      //     } else {
      //       this.tableData = doc.data.data;
      //     }
      //   });
      this.loadingFlag = false;
  },
};
</script>

<style scoped>
.myObject {
  position: absolute;
  left: 22px;
  bottom: 20px;
  color: #303133;
}

.on-btn {
  position: absolute;
  bottom: 20px;
  right: 30px;
}

.resource-title {
  position: absolute;
  top: 15px;
  left: 48px;
  font-size: 18px;
  font-family: "微软雅黑";
  color: #303133;
  font-weight: 600;
}

.resource-icon {
  position: relative;
  top: -7px;
  font-size: 27px;
  color: #303133;
  margin-bottom: 20px;
}

.resource-icon:after {
  position: absolute;
  content: "";
  display: block;
  height: 90%;
  width: 0;
  border-left: 3px solid #303133;
  left: -10px;
  top: 2px;
}

.resource {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  width: 100%;
}

.shade-chil {
  width: 1050px;
  height: 680px;
  /* background-color: RGB(249,249,249); */
  border-radius: 12px;
  box-shadow: 4px 4px 12px #888888;
  background-image: linear-gradient(#f9f9f9, #fdfdfd, #f0f0f0, #f3f3f3);

  border-left: 1px solid #bbb;
  border-top: 1px solid #bbb;
  border-right: 1px solid #888;
  border-bottom: 1px solid #888;
  padding: 20px;
  position: relative;
  z-index: 100;
  -moz-user-select: none;
  -o-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.shade-chil .listBtn-box {
  position: absolute;
  width: 670px;
  height: 30px;
  line-height: 30px;
  /* border-right: 1px solid #ddd; */
  /* border-left   1px solid #ddd */
  padding-left: 10px;
  top: -37px;
  left: 3px;
  z-index: 1000;
}
.shade-chil .listBtn-box span a {
  color: #303133;
  font-size: 10px;
}

.shade-chil .listBtn-box span i {
  color: #303133;
  font-size: 10px;
}
.resource {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  /* top: 70px; */
  width: 100%;
  /* height 505px */
  /* border-top: 1px solid #ddd; */
  /* border-bottom  1px solid #ddd */
}

.seek-box {
  position: absolute;
  width: 330px;
  height: 40px;
  top: 5px;
  right: 0px;
  z-index: 10;
}

.seek-box /deep/ .el-input__inner {
  height: 35px;
}

.seek-main {
  width: 80%;
  height: 40px;
  font-size: 14px;
  color: #888;
  border: none;
}

.seek-icon {
  font-size: 28px;
  cursor: pointer;
  color: #303133;
  position: relative;
  top: 5px;
  margin-left: 0.1em;
}

.resourceList {
  width: 100%;
  height: 560px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  /* align-content: center; */
  align-content: flex-start;
  /* position: relative; */
  overflow-y: auto;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding-left: 20px;
}

.renameTextArea {
  position: relative;
  width: 80px;
  resize: none;
  overflow: visible;
  height: auto;
  background-color: #fff;
  z-index: 1001;
}

.renameTextAreaDialog {
  position: relative;
  width: 350px;
  height: 80px;
  resize: none;
  overflow: visible;
  background-color: #fff;
  border: 1px solid #ddd;
  z-index: 1001;
}
</style>



// WEBPACK FOOTER //
// src/components/Organization/orginstore.vue